import Nav from "./modules/navs";
import SliderLogo from "./modules/slider-logo";
import ContentAndSlider from "./modules/content-and-slider";
import PricingTable from "./modules/pricing-table";
import CopyText from "./modules/copy-text";
import CountDown from "./modules/countdown";
import PrepaInAds from "./modules/prepain-ads";

document.addEventListener("DOMContentLoaded", () => {
	new Nav().init();
	new SliderLogo();
	new ContentAndSlider();
	new PricingTable();
	new CopyText();
	new CountDown().init();
	new PrepaInAds().init();
});
